// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.l-bbar .hidden{
    opacity: 0;
}
.p-inputtext.p-component {
    padding: 0.3rem 0.3rem;
}
.p-component.p-button {
    color: black;
    border: 0;
    padding: 0.3rem 0.3rem;
    vertical-align: middle;
    font-size: 0.85rem;
}
.p-component.p-button:not(.p-highlight) {
    background: transparent;
}
.p-component.p-button.p-button-icon-only {
    width: 1.6rem;
    padding: 0.3rem;
}
.p-button.p-button-icon-only .pi {
    font-size: 0.85rem;
}
.p-splitbutton.p-component {
    vertical-align: middle;
}
div.p-button.p-togglebutton.l-bbar-editor-button .p-button-icon-left {
    color: black;
}
.l-whitewall-body-container div.p-button.p-togglebutton.l-bbar-editor-button .p-button-icon-left {
    color: unset;
}
div.p-button.p-togglebutton.l-bbar-editor-button {
    background: transparent;
    border: 0;
}
div.p-button.p-togglebutton.l-bbar-editor-button:hover {
    color: white;
    background: #116fbf;
    border-color: #116fbf;
}
.p-progress-spinner .p-progress-spinner-circle {
    stroke-linecap: butt;
}
`, "",{"version":3,"sources":["webpack://./lino_react/react/components/LinoBbar.css"],"names":[],"mappings":"AAAA;IACI,UAAU;AACd;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,SAAS;IACT,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;AACzB;AACA;IACI,oBAAoB;AACxB","sourcesContent":[".l-bbar .hidden{\n    opacity: 0;\n}\n.p-inputtext.p-component {\n    padding: 0.3rem 0.3rem;\n}\n.p-component.p-button {\n    color: black;\n    border: 0;\n    padding: 0.3rem 0.3rem;\n    vertical-align: middle;\n    font-size: 0.85rem;\n}\n.p-component.p-button:not(.p-highlight) {\n    background: transparent;\n}\n.p-component.p-button.p-button-icon-only {\n    width: 1.6rem;\n    padding: 0.3rem;\n}\n.p-button.p-button-icon-only .pi {\n    font-size: 0.85rem;\n}\n.p-splitbutton.p-component {\n    vertical-align: middle;\n}\ndiv.p-button.p-togglebutton.l-bbar-editor-button .p-button-icon-left {\n    color: black;\n}\n.l-whitewall-body-container div.p-button.p-togglebutton.l-bbar-editor-button .p-button-icon-left {\n    color: unset;\n}\ndiv.p-button.p-togglebutton.l-bbar-editor-button {\n    background: transparent;\n    border: 0;\n}\ndiv.p-button.p-togglebutton.l-bbar-editor-button:hover {\n    color: white;\n    background: #116fbf;\n    border-color: #116fbf;\n}\n.p-progress-spinner .p-progress-spinner-circle {\n    stroke-linecap: butt;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
